<input
    [id]="id"
    type="checkbox"
    class="cm-checkbox"
    [checked]="value"
    [disabled]="isDisabled"
    (change)="onSelectRow($event)"
    (click)="stopPropagation($event)" />
<label [for]="id" class="cm-checkbox-label"
       [ngbTooltip]="data.row.checkboxTooltip"
       (click)="stopPropagation($event)"></label>
